import {Component, OnInit, Inject} from '@angular/core';
import {ApiUserService} from './service/api-user.service';
import {DOCUMENT} from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  currentRoute = '';

  constructor(public apiUserService: ApiUserService,
              @Inject(DOCUMENT) private document: Document,
  ) {
  }

  ngOnInit() {
    this.document.body.parentElement.setAttribute('data-version', '1.0.3');
    this.apiUserService.routerSubject
      .subscribe((val) => {
        if (val.aka === 'orguserActivate') {
          this.currentRoute = 'orguserActivate';
        } else {
          this.currentRoute = '';
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts